import EventsCard from "./EventsCard";

export default EventsCard;
